import { Link } from 'react-router'
import { NewsKicker } from '../news-meta/NewsKicker.tsx'
import { NewsMeta } from '../news-meta/NewsMeta.tsx'
import styles from './NewsCard.module.css'

export type NewsCardVariant = 'card' | 'banner'

export interface NewsCardProps {
  to: string
  title: string
  coverUrl?: string | null
  /** Topic label above the headline. */
  kicker?: string
  author?: string
  date?: string | null
  readTimeMinutes?: number
  /**
   * `card` is a stacked cover-over-headline story; `banner` is a wide row with
   * a big headline beside its cover, for "Next story" at the end of an article.
   */
  variant?: NewsCardVariant
  /** Small label over a banner's headline, e.g. "Next story". */
  eyebrow?: string
  as?: 'h2' | 'h3'
  className?: string
}

export function NewsCard({
  to,
  title,
  coverUrl,
  kicker,
  author,
  date,
  readTimeMinutes,
  variant = 'card',
  eyebrow,
  as: Heading = 'h3',
  className,
}: NewsCardProps) {
  const cover = coverUrl
    ? <img className={styles.cover} src={coverUrl} alt="" />
    : <div className={styles.placeholder} aria-hidden="true" />

  return (
    <Link to={to} className={[styles.card, styles[variant], className].filter(Boolean).join(' ')}>
      {variant === 'card' && cover}
      <div className={styles.body}>
        {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
        {kicker && <NewsKicker>{kicker}</NewsKicker>}
        <Heading className={styles.title}>{title}</Heading>
        <NewsMeta author={author} date={date} readTimeMinutes={readTimeMinutes} compact />
      </div>
      {variant === 'banner' && cover}
    </Link>
  )
}
